import { render, staticRenderFns } from "./luckWheelLogin.vue?vue&type=template&id=652636fa&scoped=true"
import script from "./luckWheelLogin.vue?vue&type=script&lang=js"
export * from "./luckWheelLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652636fa",
  null
  
)

export default component.exports